

(function () {

  //////////////////////
  // Helper Functions //
  //////////////////////
   
  const setActiveClassOnClick = (domArr, activeClass, func = false) => {
    domArr.forEach(dom => {
      dom.addEventListener('click', function() {
        if(dom.classList.contains(activeClass)) {
          dom.classList.remove(activeClass);
          return;
        } 
        domArr.forEach(c => c.classList.remove(activeClass))
        dom.classList.add(activeClass);
        
        if(func) {
          func(dom);
        }
      });
    })
  }

  // let allPlayers = [];
  // let exclusivePlayers = {};
  // const initVideo = (player, options = {}, controlOptions = {}) => {
  //   const isVideo = player.tagName.toLowerCase() === 'video';
  //   const url = isVideo ? player.querySelector('source').src : player.src;

  //   let type = url.includes('youtube') || url.includes('youtu') ? 'youtube' 
  //     : url.includes('vimeo') ? 'vimeo' : 'mp4';
    
  //   let m3u8 = false
  //   if(isVideo && url.includes('m3u8')) {
  //     type = 'application/x-mpegURL';
  //     m3u8 = true;
  //   }

  //   const videoOptions = {
  //     autoplay: false,
  //     controls: true,
  //     loop: false,
  //     muted: false,
  //     responsive: true,
  //     bigPlayButton: true,
  //     techOrder: [`${type}`, "html5"],
  //     sources: [{ "type": `video/${type}`, "src": url }],
  //     controlBar: {
  //       playToggle: true,
  //       volumePanel: false,
  //       fullscreenToggle: false,
  //       pictureInPictureToggle: false,
  //       remainingTimeDisplay: false,
  //       currentTimeDisplay: false,
  //       timeDivider: false,
  //       durationDisplay: false,
  //       liveDisplay: false,
  //       seekToLive: false,
  //       ...controlOptions
  //     },
  //     ...options
  //   }
    
  //   const ogVideoClassList = player.parentElement.classList;
  //   const video = videojs(player, videoOptions);
  //   video.addClass('vjs-nama');
    
  //   // console.log(video);

  //   if(ogVideoClassList.contains('pdp__video-wrapper')) {
  //     video.on('play', () => {
  //       $('.pdp__slider').slick('slickSetOption', 'pauseOnHover', false, true);
  //       $('.pdp__slider').slick('slickSetOption', 'autoplay', false, true);
  //       if(window.innerWidth < 768) {
  //         const bp = [{breakpoint: 767, settings: {autoplay: false, pauseOnHover: false }}]
  //         $('.pdp__slider').slick('slickSetOption', 'responsive', bp, true);
  //       }
  //     });

  //     // if video is playing show controls on hover
  //     video.on('touchstart', (e) => pauseVideo(e.target.tagName));
  //     video.on('click', (e) => pauseVideo(e.target.tagName));
  //     const pauseVideo = (tag) => {
  //       if(tag === 'VIDEO') 
  //         if(video.paused()) 
  //           video.play();
  //         else 
  //           video.pause();
  //     }

  //     $('.pdp__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  //       video.pause();
  //     });

  //     video.on('ended', () => {
  //       $('.pdp__slider').slick('slickSetOption', 'pauseOnHover', true, true);
  //       $('.pdp__slider').slick('slickSetOption', 'autoplay', true, true);
  //       // console.log($('.pdp__slider').slick('slickGetOption', 'autoplay'));
  //       if(window.innerWidth < 768) {
  //         const bp = [{breakpoint: 767, settings: {autoplay: true, pauseOnHover: true }}]
  //         $('.pdp__slider').slick('slickSetOption', 'responsive', bp, true);
  //       }
  //     })

  //   }

  //   // let controls = [];
  //   // const plyrInterval = setInterval(() => {
  //   //   if(extraControls && extraControls.includes('none')) {
  //   //     controls = [
  //   //       'play-large',
  //   //       'fullscreen',
  //   //       'clickToPlay',
  //   //       `${extraControls ? !extraControls.includes('mute')? 'volume' : 0 : 'volume'}`
  //   //     ]
  //   //   } else {
  //   //     controls = [
  //   //       'play-large',
  //   //       'play',
  //   //       'fullscreen',
  //   //       'clickToPlay',
  //   //       `${extraControls ? !extraControls.includes('mute')? 'volume' : 0 : 'volume'}`
  //   //     ];
  //   //   }

  //   //   controls = controls.filter(n => n);

  //   //   let mute = false;
  //   //   let autoplay = false;
  //   //   let loop = { active: false }
  //   //   if(extraControls) {
  //   //     extraControls.split(' ').forEach(control => controls.push(control));
  //   //     mute = extraControls.includes('mute') ? true : false;
  //   //     autoplay = extraControls.includes('autoplay') ? true : false;
  //   //     loop.active = extraControls.includes('loop') ? true : false;
  //   //   }

  //   //   if(typeof Plyr !== "undefined" && Plyr) {
  //   //     const plyr = new Plyr(player, {
  //   //       controls, 
  //   //       muted: mute,
  //   //       loop: loop,
  //   //       volume: extraControls ? !extraControls.includes('mute')? 1 : 0 : 1,
  //   //       autoplay: autoplay,
  //   //       fullscreen: {
  //   //         enabled: true,
  //   //         iosNative: true
  //   //       },
  //   //       vimeo: { muted: false, volume: 1 }
  //   //     });
        
  //   //     allPlayers.push(plyr);
  //   //     // Always Unavailable for launching and until we know how this section will be
  //   //     // This following code may or may not be in the last draft
  //   //     if(activeClass && false) {
  //   //       if(!exclusivePlayers[activeClass]) {
  //   //         exclusivePlayers[activeClass] = {};
  //   //         exclusivePlayers[activeClass].players = [];
  //   //       }

  //   //       // Set for main video to switch up in Video Section
  //   //       if(player.parentNode.classList.contains(activeClass)){
  //   //         exclusivePlayers[activeClass].mainVideo = plyr;
  //   //       }
  //   //       exclusivePlayers[activeClass].players.push(plyr);

          
          
  //   //       plyr.on('click', (event) => {
  //   //         if(window.innerWidth >= 768) {
  //   //           const playerClick = event.srcElement;
  //   //           const playerParent = playerClick.parentNode.parentNode.parentNode;
  //   //           if(!playerParent.classList.contains(activeClass) && activeClass) {
  //   //             const mainSource = plyr.source.split('v=')[1];
  //   //             const thumbSource = exclusivePlayers[activeClass].mainVideo.source.split('v=')[1];

  //   //             exclusivePlayers[activeClass].mainVideo.source = {
  //   //               type: 'video',
  //   //               sources: [
  //   //                 {
  //   //                   src: `${mainSource}`,
  //   //                   provider: 'youtube'
  //   //                 }
  //   //               ]
  //   //             };
  //   //             plyr.source = {
  //   //               type: 'video',
  //   //               sources: [
  //   //                 {
  //   //                   src: `${thumbSource}`,
  //   //                   provider: 'youtube'
  //   //                 }
  //   //               ]
  //   //             };

  //   //             const mainVideoNode = document.querySelector(`.${activeClass}`);
  //   //             const mainVideo = mainVideoNode.querySelector('[data-player]');
  //   //             const mainVideoNextSibling = mainVideoNode.querySelector(`[data-player-text]`);

  //   //             const playerIndex = player.getAttribute('data-player')
  //   //             const playerNextSibling = document.querySelector(`[data-player-text="${playerIndex}"]`);

  //   //             const mainVideoTitle = mainVideoNextSibling.innerText;
  //   //             const playerTitle = playerNextSibling.innerText;

  //   //             mainVideo.setAttribute('data-player-title', playerTitle);
  //   //             player.setAttribute('data-player-title', mainVideoTitle);

  //   //             mainVideoNextSibling.innerText = playerTitle;
  //   //             playerNextSibling.innerText = mainVideoTitle;

  //   //             plyr.stop();
  //   //             setTimeout(() => {
  //   //               exclusivePlayers[activeClass].mainVideo.play();
  //   //             }, 500);
  //   //           }
  //   //         }
  //   //       });
          
  //   //       plyr.on('play', (event) => {
  //   //         allPlayers.forEach(player => {if(player !== plyr) player.stop()});
  //   //         if(window.innerWidth < 768) {
  //   //           players.forEach(player => player.parentNode.parentNode.parentNode
  //   //             .classList.remove('video__video--active'));
  //   //           player.parentNode.parentNode.parentNode.classList.add('video__video--active');
  //   //         }
  //   //       })
  //   //     } else {
  //   //     }
  //   //     if(plyr.elements.container && plyr.elements.container.parentElement.classList.contains('pdp__video-wrapper')) {
  //   //       plyr.on('play', () => {
  //   //         $('.pdp__slider').slick('slickSetOption', 'pauseOnHover', false, true);
  //   //         $('.pdp__slider').slick('slickSetOption', 'autoplay', false, true);
  //   //         if(window.innerWidth < 768) {
  //   //           const bp = [{breakpoint: 767, settings: {autoplay: false, pauseOnHover: false }}]
  //   //           $('.pdp__slider').slick('slickSetOption', 'responsive', bp, true);
  //   //         }
  //   //       });
  //   //       plyr.on('ended', () => {
  //   //         $('.pdp__slider').slick('slickSetOption', 'pauseOnHover', true, true);
  //   //         $('.pdp__slider').slick('slickSetOption', 'autoplay', true, true);
  //   //         if(window.innerWidth < 768) {
  //   //           const bp = [{breakpoint: 767, settings: {autoplay: true, pauseOnHover: true }}]
  //   //           $('.pdp__slider').slick('slickSetOption', 'responsive', bp, true);
  //   //         }
  //   //       })

  //   //     }
  //   //     clearInterval(plyrInterval);
  //   //     return plyr;
  //   //   }
  //   // }, 500);
  // }

  /////////////
  // SLIDERS //
  /////////////
  // Why Juice Silider

  
  const autoplaySpeed = document.querySelector('[data-wj-slideshow-autoplay]')
    ?.getAttribute('data-wj-slideshow-autoplay');
  
  if(autoplaySpeed) {
    $('.wj__slideshow').slick({ 
      dots: true,
      autoplay: false,
      fade: true,
      cssEase: 'linear',
      autoplaySpeed: autoplaySpeed
    });
  
    // Juicing Made Easy Slideshow //
    $('.juicing__slider').slick({
      infinite: false,
      slidesToShow: 2,
      slideToScroll: 2,
      arrows: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false
          }
        }
      ]
    });
  }


  // PDP Silider
  $('.pdp__slider').slick({ 
    dots: true, 
    infinite: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    pauseOnFocus: true,
    fade: true,
    customPaging: function(slider, i) {
      const videoSlide = document.querySelector(`[data-video-index="${i}"]`);
      return `<button class="pdp__video-dot ${videoSlide ? 'dot-video-icon' : 'dot-video-img'}"></button>`;
    },
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true, 
          infinite: true,
          centerMode: false
        }
      }
    ]
  });

  $('.pdp__slider').each(function(i, slider) {
    $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $(slider).slick('slickSetOption', 'autoplay', false, false);
    });
  })

  // Reviews Slider
  $('.cr__reviews-wrapper').on('init', function(event, slick) {
    setTimeout(() => {
      let height = 0;
      Array.from(slick.$slides).forEach(slide => {
        const newHeight = slide.querySelector('.cr__review-content p').offsetHeight;
        if(height < newHeight) {
          height = newHeight
        }
      })
      document.querySelectorAll('.cr__review-content p').forEach(item => item.style.minHeight = height + 'px');
    }, 500);
  })

  $('.cr__reviews-wrapper').slick({
    dots: true,
    slidesToShow: 2, 
    centerMode: false,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true
        }
      }
    ]
  })

  let lastSlide = 0;
  const afterChangeGoTo = (slick, currentSlide) => {
    let minusSlides = window.innerWidth >= 768 ? 2 : 1;
    const lastSlideInSlider = slick.$slides.length - minusSlides;
    if(lastSlide === currentSlide) {
      if(currentSlide === 0) {
        document.querySelector('[data-juicing-tab="2"]').click();
      } 

      if(currentSlide === lastSlideInSlider) {
        document.querySelector('[data-juicing-tab="0"]').click();
      }
    }
  }

  $('.juicing__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    afterChangeGoTo(slick, currentSlide)
    lastSlide = currentSlide;
  });

  const setActiveSlider = (attr, activeClass, activeSlider) => {
    const items = document.querySelectorAll(`[${attr}]`);
    items.forEach(content => {
      if(content.getAttribute(`${attr}`) === activeSlider) {
        items.forEach((c) => c.classList.remove(activeClass))
        content.classList.add(activeClass);
      }
    });
  }

  $('.juicing__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    const slides = slick.$slides;
    const secondToLastSlide = slides[slides.length - 1].previousSibling.previousSibling;
    const opacityClass = 'slide-add-opacity'
    
    if(window.innerWidth >=768 && nextSlide === 4) {
      secondToLastSlide.classList.add(opacityClass);
    } else if(secondToLastSlide.classList.contains(opacityClass)) {
      secondToLastSlide.classList.remove(opacityClass);
    }

    if(slides[nextSlide]) {
      const activeSlider = slides[nextSlide].getAttribute('data-juicing-slide');
      const contentAttr = 'data-juicing-content';
      setActiveSlider(contentAttr, 'juicing__content-wrapper--active', activeSlider);
  
      const tabAttr = 'data-juicing-tab';
      setActiveSlider(tabAttr, 'je__tab--active', activeSlider);
    }
  });

  ////////////////
  // Video Hero //
  ////////////////

  // const video = document.querySelector('.product-page__video-hero-j2 video');
  // const options = {
  //   autoplay: true,
  //   loop: true,
  //   muted: true,
  //   controls: false,
  //   bigPlayButton: false,
  //   fill: true
  // }
  // // const controlOptions = {
  // //   playToggle: false
  // // }
  // // console.log(options);
  // if(video)
  //   initVideo(video, options);
  
  ///////////////////////
  // Juicing Made Easy //
  ///////////////////////
  let juicingTabs = document.querySelectorAll('[data-juicing-tab]');

  if(juicingTabs.length > 0) {
    const tabEventHandler = (tab) => {
      // When clicking on tabs goTo in slider
      juicingTabs.forEach(t => t.classList.remove('je__tab--active'))
      tab.classList.add('je__tab--active');
      //TODO: find a way to make it more dynamic
      const tabPos = Number(tab.getAttribute('data-juicing-tab'));
  
      let goToTab = 0;
      if(tabPos === 1)
        goToTab = 2;
      if(tabPos === 2)
        goToTab = 4;
      
      $('.juicing__slider').slick('slickGoTo', goToTab);
    }
  
    document.querySelector('[data-juicing-arrow]')
      .addEventListener('click', () => {
  
        let next = $('.juicing__slider').slick('slickCurrentSlide') + 1;
        if(window.innerWidth >= 768)
          next = (next < 2) ? 2 : (next >= 2 && next <= 4) ? 4 : 0;
        $('.juicing__slider').slick('slickGoTo', next);
      });
  
    juicingTabs.forEach(tab => {
      tab.addEventListener('click', () => tabEventHandler(tab));
    })
  }

  ///////////////
  // More Love //
  ///////////////

  let benefits = document.querySelectorAll('[data-accordion]');

  if(benefits) {

    const toggleBenefitsMobile = () => {
      const benefitsWrapper = document.querySelector('[data-accordion-wrapper]');
      const benefitsSlider = document.querySelector('[data-accordion-slider]');
      const arrows = document.querySelector('[data-accordion-arrows]');
      const back = document.querySelector('[data-accordion-back]');
  
      benefitsWrapper.classList.toggle('hidden');
      benefitsSlider.classList.toggle('hidden');
      arrows.classList.toggle('hidden');
      back.classList.toggle('hidden');
    }
      
    const setBenefitActive = benefit => {
      const mainImage = document.querySelector('[data-more-love-image]');
      const benefitImg = benefit.getAttribute('data-accordion-img');
      
      if(window.innerWidth < 768) {
        // Show Slider and hide other content
        toggleBenefitsMobile();
  
        if(!document.querySelector('.ml__slider').classList.contains('slick-initialized')) {
          // Init slider
          $('.ml__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            adaptiveHeight: true,
          });
  
          const index = benefit.getAttribute('data-accordion');
          $('.ml__slider').slick('slickGoTo', index);
          // Make arrows to work for next / prev in slider
          const leftArrow = document.querySelector('[data-arrow-left]');
          const rightArrow = document.querySelector('[data-arrow-right]');
          const back = document.querySelector('[data-accordion-back]');
  
          back.addEventListener('click', () => { toggleBenefitsMobile() });
          leftArrow.addEventListener('click', () => $('.ml__slider').slick('slickPrev'));
          rightArrow.addEventListener('click', () => $('.ml__slider').slick('slickNext'));
        } else {
          const index = benefit.getAttribute('data-accordion');
          $('.ml__slider').slick('slickGoTo', index);
        }
      } else {
        const activeClass = 'ml__contents-benefits--active'
        const benefitParent = benefit.parentNode;
        if(benefitParent.classList.contains(activeClass)) {
          setTimeout(() => benefitParent.classList.remove(activeClass), 250);
        } else {
          // Show accordion content and change image
          const desktopWrapper = document.querySelectorAll('[data-accordion-desktop]');
          desktopWrapper.forEach(accord => accord.classList.remove(activeClass))
          benefit.parentNode.classList.add(activeClass);
          mainImage.style.opacity = 0.1;
          setTimeout(() => {
            mainImage.setAttribute('src', benefitImg);
            mainImage.style.opacity = 1;
          }, 500)
        }
  
      }

      
      // $('.ml__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      //   const baseHeight = 275
      //   const offset = 40
      //   const additionalOffset = 10

      //   let a = document.querySelector(`[data-slick-index="${currentSlide}"] .ml__benefits-content p`)
      //   const imageOffset = a.offsetHeight

      //   const newPos = baseHeight - (imageOffset + offset) + additionalOffset
      //   const newPosBack = baseHeight - (imageOffset + offset) + additionalOffset - offset
        
      //   const newPixelValue = newPos.toString() + 'px'
      //   const newPixelValueBack = newPosBack.toString() + 'px'
        
      //   document.querySelector('.product__page-more-love .ml__arrows').style.bottom = newPixelValue
      //   document.querySelector('.ml__arrows-back.only-mobile').style.bottom = newPixelValueBack
      // });
    }
  
    benefits.forEach(benefit => {
      benefit.addEventListener('click', () => setBenefitActive(benefit))
    })
  }




  /////////
  // PDP //
  /////////

  const variants = document.querySelectorAll('[data-variant]');
  const pdpVideo = document.querySelectorAll('.pdp__images video');
  const notifyMeButtons = document.querySelectorAll('[data-notify-me]');
  const pdpOptions = {
    muted: true,
    controls: false
  }

  // pdpVideo.forEach(video => initVideo(video, pdpOptions));
  
  let ConvertStringToHTML = function (str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
 };

  const setVariantActive = variant => {
    // console.log("🚀 ~ file: product-j2.js ~ line 540 ~ variant", variant)
    
    const inputs = document.querySelectorAll('#pdp__variant-id');
    const variantId = variant.getAttribute('data-variant-color-id');
    const variantAvailable = variant.getAttribute('data-available');
    const preOrder = document.querySelectorAll('[data-po]');

    const atcButtons = document.querySelectorAll('[data-atc]');

    variants.forEach((variant, i) => {
      if(variant.getAttribute('data-variant-color-id') !== variantId)
        variant.classList.remove('pdp__variant-color-wrapper--selected')
      else
        variant.classList.add('pdp__variant-color-wrapper--selected')
    });

    preOrder.forEach((po, i) => {
      let arrPO = Object.assign({}, po.dataset) 
      let poData;

      Object.keys(arrPO).forEach(key => {
        if(key !== 'po') {
          const obj = JSON.parse(JSON.parse(arrPO[key]));
          
          if(obj.id === variantId) {
            poData = obj;
          }
        }
      });

      if(poData) {
        po.querySelector('[data-po-heading]').innerHTML = ConvertStringToHTML(poData.heading).firstChild.nodeValue;
        po.querySelector('[data-po-subheading]').innerHTML = ConvertStringToHTML(poData.subheading).firstChild.nodeValue;

        // po.querySelector('img').src = poData.icon;

        const tooltip = poData.tooltip.replaceAll('"', '');
        // po.querySelector('[data-po-tooltip]').innerHTML = ConvertStringToHTML(tooltip).firstChild.nodeValue;
      }
      
    });
    
    inputs.forEach(input => {
      input.setAttribute('value', variantId);
    })

    
    // Notify Me of Availability
    if(notifyMeButtons.length > 0) {
      notifyMeButtons.forEach(button => {
        button.setAttribute('data-variant-id', variantId);
        button.style.display = variantAvailable == 'true' ? 'none' : 'block';
        button.removeAttribute('disabled');
      });
    }
    
    if(atcButtons.length > 0) {
      atcButtons.forEach(button => {
        button.style.display = variantAvailable == 'true' ? 'inline-block' : 'none';
      });
    }
    

    const anchor = variant.querySelector('[data-variant-anchor]').getAttribute('data-variant-anchor');
    const imgs = document.querySelector('.pdp__slider').querySelectorAll('img')
    
    const index = Array.from(imgs).filter((img, i) => {
      if(img.alt.toLowerCase() == anchor.toLowerCase() && !img.parentElement.classList.contains('slick-cloned')) {
        return img
      }
    })
    if(index[0]) {
      $('.pdp__slider').slick('slickGoTo', index[0].parentElement.getAttribute('data-slick-index'))
    }
  }

  variants.forEach(variant => variant
    .addEventListener('click', () => setVariantActive(variant)));

  if(notifyMeButtons.length > 0) {
    notifyMeButtons.forEach(button => {
      let counter = 0;
      const checkModal = setInterval(() => {
        const modal = document.querySelector('#SI_frame');
        if(modal) {
          clearInterval(checkModal);
          button.removeAttribute('disabled');
        }  
        
        if(counter > 20) clearInterval(checkModal);
        counter++;
      }, 1000);
    });
  }

  ////////////
  // Videos //
  ////////////
  
  // const players = document.querySelectorAll('[data-player]');

  // players.forEach(player => {
  //   let videosOptions = {}
  //   if(player.tagName === 'IFRAME') {
  //     videosOptions = {
  //       bigPlayButton: false
  //     }
  //   }
  //   initVideo(player, videosOptions)
  // })

  /////////////////
  // Collapsible //
  /////////////////

  const collapsibles = document.querySelectorAll('[data-collapsible]');
  setActiveClassOnClick(collapsibles, 'collapsible-j2-active');

  const detailLinks = document.querySelectorAll('[data-details-link]');
  setActiveClassOnClick(detailLinks, 'details__link--active');
  
  ////////////////////
  // Custom Reviews //
  ////////////////////

  // const sortFilter = document.querySelector('[data-filter-select]');

  const slickFilter = (activeTag) => {
    $('.cr__reviews-wrapper').slick('slickUnfilter');

    const allTaggedElements = document.querySelectorAll('[data-tags]');

    const tagFiltered = Array.from(allTaggedElements).filter(tagElement => {
      let tagEleTags = tagElement.getAttribute('data-tags').toLowerCase();
      return tagEleTags.includes(activeTag);
    })

    if(activeTag !== 'all') {
      $('.cr__reviews-wrapper').slick('slickFilter', tagFiltered);
      $('.cr__reviews-wrapper').slick('refresh');
    }
  }

  // sortFilter.addEventListener('change', e => {
  //   if(window.innerWidth < 786) {
  //     const activeTag = e.target.value;
  //     const activeTagDom = document.querySelector('[data-active-tag]');
  //     console.log(activeTag);
  //     activeTagDom.innerText = activeTag.toUpperCase();
  //     slickFilter(activeTag.toUpperCase());
  //   }
  // })

  const tagButtons = document.querySelectorAll('[data-filter-button]');
  const filterButton = (ele) => {
    const filterBy = ele.getAttribute('data-filter-button');
    slickFilter(filterBy)
  }
  setActiveClassOnClick(tagButtons, 'cr__filters-desktop--active', filterButton);

  //! Should I set height ??
  
  // const allTags = document.querySelectorAll('[data-tags]');
  // let tagHeights = 0;
  // allTags.forEach((ele) => {
  //   if(ele.offsetHeight > tagHeights) {
  //     tagHeights = ele.offsetHeight;
  //   }
  // })
  // allTags.forEach((ele) => {
  //   ele.style.minHeight = tagHeights + 'px';
  // });

})();
